var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#880C55",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 250 l0 -210 40 0 c29 0 40 -4 40 -15 0 -18 4 -19 30 -3 16 10 24 10 40 0 26 -16 30 -15 30 3 0 12 16 15 80 15 l80 0 0 210 0 210 -170 0 -170 0 0 -210z m270 80 c0 -6 -40 -10 -100 -10 -60 0 -100 4 -100 10 0 6 40 10 100 10 60 0 100 -4 100 -10z m0 -60 c0 -6 -40 -10 -100 -10 -60 0 -100 4 -100 10 0 6 40 10 100 10 60 0 100 -4 100 -10z m-98 -94 c15 -23 8 -53 -17 -66 -46 -25 -96 24 -67 66 16 25 68 25 84 0z m-12 -117 c0 -18 -2 -19 -15 -9 -12 10 -18 10 -30 0 -13 -10 -15 -9 -15 9 0 17 6 21 30 21 24 0 30 -4 30 -21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutCertificate);
export default __webpack_public_path__ + "static/media/About_Certificate.95fa5c0bda1255989212e9b2e60aa35d.svg";
export { ForwardRef as ReactComponent };